module.exports = __webpack_public_path__ + "img/Rocky_Linux.aed45ee.svg";